import React, {useEffect, useState} from 'react';
import '../../dmView/style/App.css'; // Import your CSS file

import skullpng from '../pics/imageOverlays/skulls/skull.png'; 
import bloodied1 from '../pics/imageOverlays/blood/blood1.png'; 
import bloodied2 from '../pics/imageOverlays/blood/blood2.png'; 
import bloodied3 from '../pics/imageOverlays/blood/blood3.png'; 
import bloodied4 from '../pics/imageOverlays/blood/blood4.png'; 
import bloodied5 from '../pics/imageOverlays/blood/blood5.png'; 
import bloodied6 from '../pics/imageOverlays/blood/blood6.png'; 
import Exhaustion from './Exhaustion'; 
import DeathSaves from './DeathSaves';
import { effectImgMap, conditionImgMap } from '../../dmView/constants'
import PlayerUiHpWidget from './PlayerUI/CharacterChosen/PlayerUiHpWidget.js';
import PlayerUiNameWidget from './PlayerUI/CharacterChosen/PlayerUiNameWidget.js';
import PlayerUiEffectWidget from './PlayerUI/CharacterChosen/PlayerUiEffectWidget.js';
import PlayerUiInitWidget from './PlayerUI/CharacterChosen/PlayerUiInitWidget.js';

import WidgetPopUp from '../../dmView/components/EncounterColumn/WidgetPopUp.js';
import OptionButton from '../../dmView/components/EncounterColumn/OptionButton.js';
import EffectImg from '../../dmView/pics/icons/effectImg.png';

// Grab the digits out of creatureGuid
function stringToInt(str) {
    const numericStr = str.replace(/\D/g, '');  
    return numericStr ? parseInt(numericStr, 10) : 1;
}

function getBloodImg(creature) {
    const bloodiedArr = [bloodied1, bloodied2, bloodied3, bloodied4, bloodied5, bloodied6]
    const randomNumber = (stringToInt(creature.creatureGuid) % 6); // Generates numbers from 0 to 5
    return bloodiedArr[randomNumber]
}

const InspirationSvg = ({inspired=true, type, clickable=false, handleClick}) => {
    let fill = "#9d9d9d";
    if(inspired) {
        fill = "#c53131";
    }

    return (
        <div className="inspoContainer" style={{animation: inspired ? 'inspoPulse 5s ease-in-out infinite' : ''}} onClick={handleClick}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 30" className="inspoSvg">
                <g>
                    {type === 'bardic' ? (
                        <>
                           <g transform="scale(0.3) translate(25, 0)">
                               <path fill={fill} stroke="white" strokeWidth="4" d="m93.161 0.071c-33.501-1.114-60.941 11.243-60.941 11.243l-0.02 62.709c-3.411-1.354-7.559-1.675-11.772-0.651-9.083 2.207-15.031 9.82-13.285 17.007s10.524 11.225 19.606 9.019c8.564-2.081 14.338-8.969 13.507-15.772v-46.855s19.404-6.784 44.573-8.485v34.849c-3.374-1.292-7.443-1.585-11.579-0.58-9.083 2.206-15.031 9.819-13.285 17.007 1.745 7.187 10.523 11.224 19.606 9.018 7.931-1.927 13.471-7.977 13.587-14.264l0.003 0.004v-74.249z"/>
                           </g>
                        </>
                    ) : ( 
                        <>
                            <path fill={fill} stroke="white" strokeWidth="1" d="M25,14.2c-6.4,0-11.7,5.1-12.2,11.5H2.2V30h10.9h23.8h10.9v-4.3H37.2C36.7,19.3,31.4,14.2,25,14.2z"></path>
                            <path fill={fill} stroke="white" strokeWidth="1" d="M26.9,10.3V0h-3.7v10.3c0.6-0.1,1.2-0.1,1.9-0.1S26.3,10.2,26.9,10.3z"></path>
                            <path fill={fill} stroke="white" strokeWidth="1" d="M42.4,5.3l-3-2.3l-6.4,9.1c1.1,0.5,2.2,1.2,3.1,2.1L42.4,5.3z"></path>
                            <path fill={fill} stroke="white" strokeWidth="1" d="M41.7,22.1l8.3-3.1l-1.3-3.6L40,18.7C40.7,19.7,41.3,20.9,41.7,22.1z"></path>
                            <path fill={fill} stroke="white" strokeWidth="1" d="M17.1,12.1L10.6,3l-3,2.3l6.3,8.9C14.9,13.3,16,12.6,17.1,12.1z"></path>
                            <path fill={fill} stroke="white" strokeWidth="1" d="M10,18.7l-8.7-3.3L0,18.9l8.3,3.1C8.7,20.9,9.3,19.7,10,18.7z"></path>}
                        </>
                    )}
                </g>
            </svg>
        </div>
    )
}

const ShieldSvg = ({ac, tableView, iconSize}) => {

    let mod = tableView ? 4 : 8;

    const width = iconSize.width / mod;
    const height = iconSize.height / mod;

    if(typeof ac === 'string') {
        ac = ac.split(' ')[0]
    }
    
    return (
        <span className='acDiv'>
            <svg height={height} width={width} viewBox="0 0 476 476">
                <path fill="#ececec" d="M442.138,11.508c-1.107-4.625-4.342-8.45-8.718-10.312s-9.375-1.537-13.476,0.875c-53.767,31.626-120.569,31.628-174.34,0 c-4.692-2.762-10.516-2.762-15.21,0c-53.768,31.627-120.571,31.627-174.339,0c-4.099-2.412-9.099-2.734-13.475-0.875 c-4.376,1.861-7.611,5.687-8.718,10.312C-4.815,173.094,55.859,342.213,188.436,442.359l40.522,30.61 c2.675,2.021,5.857,3.031,9.041,3.031c3.183,0,6.367-1.011,9.042-3.031l40.522-30.61 C420.141,342.213,480.815,173.094,442.138,11.508z M269.482,418.421L238,442.201l-31.481-23.78 C88.624,329.366,31.987,181.539,59.004,37.407C115.969,63.545,182.278,61.805,238,32.185c55.724,29.62,122.03,31.361,178.996,5.222 C444.013,181.539,387.376,329.366,269.482,418.421z"/>
                <path fill="#000000" d="M397.194,71.145c-2.409-1.708-5.451-2.265-8.304-1.519c-18.303,4.766-37.182,7.183-56.114,7.183 c-30.958,0-62.325-6.672-90.712-19.296c-2.588-1.15-5.54-1.15-8.127,0c-28.386,12.624-59.753,19.296-90.711,19.296 c-18.933,0-37.813-2.417-56.115-7.183c-2.857-0.745-5.896-0.188-8.303,1.519s-3.938,4.391-4.183,7.332 c-4.871,58.737,4.658,118.513,27.557,172.864c25.044,59.444,65.5,111.425,116.995,150.323l12.797,9.666 c1.783,1.347,3.905,2.021,6.027,2.021s4.244-0.674,6.027-2.021l12.796-9.666c51.496-38.899,91.952-90.881,116.996-150.323 c22.898-54.352,32.428-114.127,27.557-172.864C401.132,75.535,399.602,72.852,397.194,71.145z M355.388,243.575 c-23.678,56.202-61.93,105.351-110.619,142.13L238,390.819l-6.77-5.113c-48.688-36.778-86.94-85.926-110.619-142.13 c-20.146-47.818-29.348-100.077-26.819-151.852c16.242,3.377,32.819,5.085,49.433,5.085c32.266,0,64.934-6.648,94.775-19.259 c29.842,12.61,62.51,19.259,94.775,19.259c16.613,0,33.19-1.708,49.433-5.085C384.737,143.498,375.535,195.757,355.388,243.575z"/>
                <text fill="black" x="238" y="230" fontSize="300" fontWeight="bold" textAnchor="middle" dominantBaseline="middle">
                    {ac}
                </text> 
            </svg>
        </span>
        
    )
}

const HealthBar = ({ current, max, iconSize, color }) => {
    const width = iconSize.width / 1.5;
    const height = iconSize.height / 30;
    const outlineWidth = iconSize.height / 100;

    const percent = Math.max(0, Math.min(1, current / max));
    const barWidth = width * percent;
    const gradientId = `hpGradient-${color}`;

    return (
        <div className='playerViewHpBar' style={{height: height + outlineWidth}}>    
            <svg width={width + outlineWidth} height={height + outlineWidth}>
                <defs>
                    <linearGradient id={gradientId} x1="0" y1="0" x2="0" y2="1">
                        <stop offset="0%" stopColor="#ffffff" />
                        <stop offset="30%" stopColor={color} />
                    </linearGradient>
                </defs>
                <rect
                    x={outlineWidth / 2}
                    y={outlineWidth / 2}
                    width={width}
                    height={height}
                    fill="#111"
                    rx={2}
                    stroke="#ddd"
                    strokeWidth={outlineWidth}
                />
                <rect
                    x={outlineWidth}
                    y={outlineWidth}
                    width={barWidth - outlineWidth}
                    height={height - outlineWidth}
                    fill={`url(#${gradientId})`}
                    rx={1}
                />
            </svg>
        </div>
    );
};

// Send in specific player or monster blood effects
const Icon = ({creature, iconOptions, iconSize, isTurn, clickable=false, smallIcon=false, socket=undefined}) => {

    let tableView = window.location.pathname.includes('table') || smallIcon
    const [inspiration, setInspiration] = useState(creature.inspiration);
    const [bardicInspiration, setBardicInspiration] = useState(false);

    useEffect(() => {
        if(inspiration !== creature.inspiration)
            setInspiration(creature.inspiration)
    }, [creature.inspiration])

    const handleInspirationClick = () => {
        console.log("Inspiration clicked for creature:", creature.creatureGuid);
        creature.inspiration = !inspiration; // Update the creature's inspiration property
        setInspiration(!inspiration);
        socket.emit('creatureInspirationChange', !inspiration, creature.creatureGuid, "player");

    }

    const handleBardicInspirationClick = () => {
        console.log("Bardic Inspiration clicked for creature:", creature.creatureGuid);
        creature.bardicInspiration = !bardicInspiration; // Update the creature's bardic inspiration property
        setBardicInspiration(!bardicInspiration);
    }

    // Player specific
    const isPlayer = creature.type === "player";
    let showDeathSaves = iconOptions.deathSaves && isPlayer && (creature.death_saves_success_count >= 0 && creature.death_saves_failure_count >= 0)

    const effectsFound = creature.effects.length > 0
    const showInitiativeBox = creature.initiative !== null && creature.initiative !== undefined && creature.initiative !== 0;
    const isExhausted = creature.exhaustionLvl > 0
    const hpPercent = creature.hit_points_current / creature.hit_points;

    let isDead = (creature.hit_points_current <= 0 || creature.exhaustionLvl === 6) && creature.type !== "global"
    let showHp = iconOptions.showHp
    let hpBar =  iconOptions.showHpBar
    let showAc = iconOptions.showAc
    
    let isBloodied = false;
    let tableViewHpColor = hpPercent > 0.55 ? 'green' : (hpPercent < 0.20 ? 'rgba(192, 47, 31, 1)' : 'rgba(214, 147, 1, 1)');

    if (hpPercent < 0.55 && iconOptions.showBlood) {
        isBloodied = true;
    }

    // By default, make ths name the same as the creature name
    // If it's a player, split the name into first and last names
    let name = creature.name;
    let lastName;
    if (isPlayer) {
        let restOfName;
        [name, ...restOfName] = creature.name.split(' ');
        lastName = restOfName.join(' ') || '';
    }

    if(!iconOptions.showDead && isDead) return null

    let sizes = {
        'tiny': .6,
        'small': .7,
        'medium': 1,
        'huge': 1.15,
        'large': 1.2,
        'gargantuan': 1.4
    };

    let teamWmod = 20 * iconOptions.teamSize || 0
    let teamHmod = 24 * iconOptions.teamSize || 0
    let sizeMod = iconOptions.showSize ? (sizes[creature.size?.toLowerCase()] || 1) : 1;
    iconSize = {width: (iconSize.width + teamWmod) * sizeMod, height: (iconSize.height + teamHmod) * sizeMod}
    let effectsCount = creature.effects.length > 0 ? `x${creature.effects.length}` : ''

    return (
        <div className='iconImageDrop'>
            <div className="card"
                style={{
                    animation: isTurn ? 'playerViewIconShadowPulse 3s ease-in-out infinite' : '',
                    opacity: isDead && !isPlayer ? 0.75 : 1,
                    '--static-border': creature.border,
                    '--tableViewBlur': `${tableView ? '0px' : '5px'}`, 
                    boxShadow: `${tableView ? `0px 0px 0px ${iconSize.width/15}px` : '0px 0px 4px 5px'} ${creature.border}`, 
                    border: isTurn ? '4px solid #ffffffff' : '2px solid #d3d3d3ff',
                    width: `${iconSize.width + (isTurn ? iconSize.width/5 : 0)}px`,
                    height: `${iconSize.height + (isTurn ? iconSize.height/5 : 0)}px`,
                    '--iconWidth': `${iconSize.width + (isTurn ? iconSize.width/4 : 0)}px`, 
                    backgroundColor: tableView ? '#949e9bff': '#949e9bce',
                    marginTop: tableView ? '38px' : '0px'
                }}
            >
                {tableView && (
                    <>
                        <div className='overIconTableViewContainer'>
                            {effectsFound && (
                                <div className='effectsBarTableViewContainer'>
                                    <div className='effectsBarTableView'>    
                                        {creature.effects.map((effectName) => (
                                            <img className='effectPlayerViewTableView'
                                                key={effectName}
                                                src={effectImgMap[effectName] || conditionImgMap[effectName]}
                                                alt={effectName}
                                            />
                                        ))}
                                    </div>
                                </div>
                                
                            )}
                            <div className="hpTableViewContainer" >
                                {showHp && ( 
                                    <div className="hpTableView" 
                                        style={{
                                            borderBottom: `2px solid ${tableViewHpColor}`, 
                                            borderTop: `3px solid ${tableViewHpColor}`,
                                            textShadow: `-2px -2px 0 ${tableViewHpColor}, 2px -2px 0 ${tableViewHpColor}, -2px 2px 0 ${tableViewHpColor}, 2px 2px 0 ${tableViewHpColor}`

                                        }}>
                                        <span>{creature.hit_points_current}</span>
                                        {creature.hit_points_temp > 0 && <span className='tempHp hpTableViewSmall'>+{creature.hit_points_temp}</span>}
                                        <span className='hpTableViewSmall'> / {creature.hit_points}</span>
                                    </div>
                                )}
                            </div>

                            {showAc && ( 
                                <div className="acContainer" style={{right: showHp ? '-12%' : '35%', bottom: hpBar ? '28%' : '5%' }}>
                                    <ShieldSvg ac={creature.armor_class} tableView={tableView} iconSize={iconSize}/>
                                </div>
                            )}

                            {hpBar && (
                                <div className='hpBarTableViewContainer'>
                                    <div className='hpBarTableView'>    
                                        <HealthBar current={creature.hit_points_current} max={creature.hit_points} iconSize={{width: iconSize.width*1.5, height: iconSize.height*2}} color={creature.border} />
                                    </div>
                                </div>
                                
                            )}
                        </div>
                    </>
                )}

                <div className='image-container'>
                    <img className="image" src={creature.avatarUrl} alt={name} style={{ outline: isTurn ? '2px solid rgba(255, 255, 255, 1)' : ''}}/>
                    
                    {isDead ? (
                        <>
                            <img className="image overlay-skull" src={skullpng} alt="" />
                            {showDeathSaves && (
                                <div style={{width: "65%"}}>
                                    <DeathSaves pass={creature.death_saves_success_count} fail={creature.death_saves_failure_count} />
                                </div>
                            )}
                        </>
                    ) : (
                        <>
                            {isBloodied && 
                                <img className="image" style={{opacity: tableView ? '1': '.8'}} src={getBloodImg(creature)} alt="" />
                            }
                        </>
                    )}       

                    {(showInitiativeBox || clickable) && 
                        <div className={tableView ? "initTableViewContainer" : "initDivContainer"}>
                            <WidgetPopUp 
                                triggerClass='initTriggerClass'
                                popOverClass='initPopOverClass'
                                trigger={
                                    <div className={tableView ? 'initTableView' : 'initDiv'}>
                                        <span>{creature.initiative}</span>
                                    </div>

                                }
                                popUp={
                                    <PlayerUiInitWidget creature={creature} socket={socket}/>
                                }
                                side='left' 
                                sideOffset={0}
                                alignOffset={0}
                                popOverClassContainer={"arrowPopOver"}
                                closeButton={true}
                                disabled={!clickable}
                            />
                        
                        </div>
                    }         

                    {!tableView &&
                        <>
                            {effectsFound && (
                                <div className='avatarEffectsBar'>    
                                    {creature.effects.map((effectName) => (
                                        <img className='effectPlayerView'
                                            key={effectName}
                                            src={effectImgMap[effectName] || conditionImgMap[effectName]}
                                            alt={effectName}
                                        />
                                    ))}
                                </div>
                            )}
                            
                            <div className='inspoFlexContainer'> 
                                {(bardicInspiration || clickable) &&
                                    <InspirationSvg inspired={bardicInspiration} type="bardic" clickable={clickable} handleClick={handleBardicInspirationClick} />
                                }
                                {(inspiration || clickable) &&
                                    <InspirationSvg inspired={inspiration} clickable={clickable} handleClick={handleInspirationClick} />
                                }

                            </div>

                            <div className="hpContainer">
                                <div className="iconHpAcFlex">
                                    <WidgetPopUp 
                                        triggerClass='playerUiTriggerClass'
                                        trigger={
                                            <OptionButton src={EffectImg} message={`Effects ${effectsCount}`} imgStyle={{opacity: clickable ? 1 : 0,margin: 0, animation: effectsCount ? 'shadowPulse 4s ease-in-out infinite' : ''}}/>
                                        }
                                        popUp={
                                            <PlayerUiEffectWidget creature={creature} socket={socket}/>
                                        }
                                        side='top' 
                                        sideOffset={0}
                                        alignOffset={80}
                                        popOverClassContainer={"arrowPopOver"}
                                        closeButton={true}
                                    />
                                    {(showHp || clickable) && ( 
                                        <WidgetPopUp 
                                            triggerClass='playerUiTriggerClass'
                                            trigger={
                                                <div className="hpDiv" 
                                                    style={{
                                                        borderTop: `3px solid ${tableViewHpColor}`,
                                                        textShadow: `-2px -2px 0 ${tableViewHpColor}, 2px -2px 0 ${tableViewHpColor}, -2px 2px 0 ${tableViewHpColor}, 2px 2px 0 ${tableViewHpColor}`
                                                    }}>
                                                    <span>{creature.hit_points_current}</span>
                                                    {creature.hit_points_temp > 0 && <span className='tempHp hpDivSmall'>+{creature.hit_points_temp}</span>}
                                                    <span className='hpDivSmall'> / {creature.hit_points}</span>
                                                    
                                                </div>
                                            }
                                            popUp={
                                               <PlayerUiHpWidget creature={creature} socket={socket}/>
                                            }
                                            side='bottom' 
                                            sideOffset={-40}
                                            alignOffset={0}
                                            popOverClassContainer={"arrowPopOver"}
                                            closeButton={true}
                                        />
                                    )}
                                    {(showAc || clickable) && ( 
                                        <WidgetPopUp 
                                            triggerClass='playerUiTriggerClass'
                                            trigger={
                                                <ShieldSvg ac={creature.armor_class} iconSize={iconSize} />
                                            }
                                            popUp={
                                                <PlayerUiHpWidget creature={creature} socket={socket}/>
                                            }
                                            side='bottom' 
                                            sideOffset={-45}
                                            alignOffset={0}
                                            popOverClassContainer={"arrowPopOver"}
                                            closeButton={true}
                                        />
                                    )}
                                </div>
                                {hpBar && (
                                    <HealthBar current={creature.hit_points_current} max={creature.hit_points} iconSize={iconSize} color={creature.border} />
                                )}
                            </div>
                        </>
                
                    }
                    
                </div>
                
                <div className={tableView ? 'iconNameTableViewContainer' : 'iconNameContainer'}>
                    {tableView && creature.inspiration &&
                        <InspirationSvg />
                    }

                    <WidgetPopUp 
                        triggerClass=''
                        trigger={
                            <>
                                <div className={tableView ? "nameTableView" : "name"} style={tableView ? {height: '16%'} : {}}>{name}</div> 
                                <div className={tableView ? "lastNameTableView" : "lastName"}> {lastName}</div>
                            </>
                        }
                        popUp={
                            <PlayerUiNameWidget creature={creature} socket={socket}/>
                        }
                        side='top' 
                        sideOffset={-35}
                        alignOffset={80}
                        popOverClassContainer={"arrowPopOver"}
                        closeButton={true}
                        disabled={!clickable}
                    />
                </div>

                <>
                    {isExhausted && !tableView && ( 
                        <Exhaustion exhaustionLvl={creature.exhaustionLvl}/>
                    )}
                </>
            </div>
        </div>
    );
};

export default Icon;